import styled from 'styled-components';

const TabsContainer = styled.div`
  .nav-tabs {
    border-bottom: none;
    margin-bottom: 24px;
    .nav-link {
      background-color: transparent;
      border: none;
      padding: 0;
    }
  }
`;

export default TabsContainer;
